import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { isNative } from './platform';

enum PaymentReturnStatus {
  Paid = 'paid',
  Canceled = 'canceled',
  Gift = 'gift',
  Guest = 'guest',
}

enum PaymentReturnKind {
  Flight = 'flight',
  Gift = 'gift',
  Guest = 'guest',
}

const paymentReturnStatuses = new Set<string>(Object.values(PaymentReturnStatus));
const paymentReturnKinds = new Set<string>(Object.values(PaymentReturnKind));

function paymentReturnStatus(value: string | null): PaymentReturnStatus {
  return value && paymentReturnStatuses.has(value) ? value as PaymentReturnStatus : PaymentReturnStatus.Paid;
}

function paymentReturnKind(value: string | null): PaymentReturnKind | null {
  return value && paymentReturnKinds.has(value) ? value as PaymentReturnKind : null;
}

export function registerDeepLinks() {
  if (!isNative) return;
  App.addListener('appUrlOpen', ({ url }) => {
    if (!url.startsWith('launchoflove://payment')) return;
    Browser.close().catch(() => undefined);
    const params = new URL(url).searchParams;
    const status = paymentReturnStatus(params.get('status'));
    const kind = paymentReturnKind(params.get('kind'));
    const sessionId = params.get('session_id');
    const sid = sessionId ? `&session_id=${encodeURIComponent(sessionId)}` : '';
    if (status === PaymentReturnStatus.Gift) {
      // Gift purchase: return to the certificate, which confirms via session id.
      window.location.assign(`/gift/certificate${sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : ''}`);
      return;
    }
    if (status === PaymentReturnStatus.Guest) {
      window.location.assign(`/reserve/finish${sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : ''}`);
      return;
    }
    if (status === PaymentReturnStatus.Canceled) {
      if (kind === PaymentReturnKind.Guest) window.location.assign('/reserve?canceled=1');
      else if (kind === PaymentReturnKind.Gift) window.location.assign('/gift?canceled=1');
      else window.location.assign('/pets?canceled=1');
      return;
    }
    // Forward the session id so Pets.vue can confirm payment without the webhook.
    window.location.assign(`/pets?paid=1${sid}`);
  });
}
